export const JS_FULL_RESUME_DETAILS_SUCCESS = 'JS_FULL_RESUME_DETAILS_SUCCESS';
export const JS_FULL_RESUME_DETAILS_FAIL = 'JS_FULL_RESUME_DETAILS_FAIL';
export const RESUMES_PROJECTS_DATA = 'PROJECTS_DATA';
export const UPDATE_SUMMARY = 'UPDATE_SUMMARY';
export const UPDATE_SKILLS = 'UPDATE_SKILLS';
export const UPDATE_PERSONAL_DETAILS = 'UPDATE_PERSONAL_DETAILS';
export const UPDATE_PROJECTS = 'UPDATE_PROJECTS';
export const UPDATE_EDUCATION_DETAILS = 'UPDATE_EDUCATION_DETAILS';
export const UPDATE_CERTIFICATIONS = 'UPDATE_CERTIFICATIONS';
export const RESET_RESUME = 'RESET_RESUME';
export const SET_CURRENT_SECTION = 'SET_CURRENT_SECTION'; 
export const OPEN_SHARE_INTERESTED = 'OPEN_SHARE_INTERESTED';
export const CLOSE_SHARE_INTERESTED =  'CLOSE_SHARE_INTERESTED';